module.exports = __webpack_public_path__ + "img/team.38090d5d.jpg";